import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { browserTrack } from 'utils/segment';

import './CategoryNav.scss';

const CategoryNav = ({ title, categories, activeSlug }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleMobileClick = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleTrack = (label) => {
    browserTrack('Content Filtered', {
      content_type: window.location.pathname.split('/')[1],
      text: label,
      style: 'category-nav',
    });
  };

  useEffect(() => {
    const outsideClick = () => {
      if (mobileOpen) {
        handleMobileClick();
      }
    };

    document.addEventListener('click', outsideClick);
    return () => {
      document.removeEventListener('click', outsideClick);
    };
  });

  const activeCategory = categories.find((cat) => {
    return cat.slug === activeSlug;
  });

  return (
    <div className="CategoryNavWrapper">
      {title && <h1>{title}</h1>}
      <nav className={'CategoryNav' + (mobileOpen ? ' isOpen' : '')}>
        <h5 className="CategoryNavHeader isDesktop">Categories</h5>
        <button className="CategoryNavHeader isMobile" title="Navigate to a blog category" onClick={handleMobileClick}>
          Category: {activeCategory && (activeCategory.label || 'All')}
        </button>
        <ul className="CategoryNavList">
          {categories.map((cat) => {
            return (
              <li key={cat.link}>
                <Link
                  className={activeSlug === cat.slug ? 'sel' : null}
                  to={cat.link}
                  title={cat.label + ' Category'}
                  onClick={() => handleTrack(cat.label)}
                >
                  {cat.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default CategoryNav;
